import { jsx as _jsx } from "react/jsx-runtime";
import { getMandantMenuItems } from "@apptypes/mandantMenuItems";
import { useAppInitialization } from "@hooks/useAppInitialization";
import { useMenuItemsLoader } from "@hooks/useMenuItemsLoader";
import { useNavigate } from "react-router-dom";
import BaseLayout from "./BaseLayout";
import CommonLayout from "./CommonLayout";
var MandantLayout = function () {
    /**
     * Custom hook for application initialization (fetching user data, menu, etc.).
     * @type {object}
     * @property {boolean} loading - Indicates if app initialization is in progress.
     * @property {() => Promise<void>} handleLogout - Function to handle user logout.
     */
    var handleLogout = useAppInitialization().handleLogout;
    var navigate = useNavigate();
    var menuItems = useMenuItemsLoader(getMandantMenuItems(navigate));
    return (_jsx(BaseLayout, { handleLogout: handleLogout, children: _jsx(CommonLayout, { menuItems: menuItems }) }));
};
export default MandantLayout;
